module.exports = __webpack_public_path__ + "static/media/success.a347a420.svg";